import React, { useEffect, useState } from 'react';
import { Container } from './styles';
import MainTitle from 'components/MainTitle';
import Heading from 'components/Heading';
import TransportSeturForm from './components/TransportSeturForm';
import { useParams } from 'react-router';
import { useLoading } from 'hooks/useLoading';
import TouristOffersBusinessService from 'services/TouristOffersBusinessService';

const TransportForm = (): JSX.Element => {
  const { id } = useParams<{ id?: string }>();
  const { openLoading, closeLoading } = useLoading();
  const [selectedTransport, setSelectedTransport] = useState<any>(null);

  useEffect(() => {
    openLoading();
    const fetchBusinessTransportData = [fetchTouristOffersTransport()];
    Promise.all(fetchBusinessTransportData).finally(() => closeLoading());
  }, []);

  const service = new TouristOffersBusinessService();

  const fetchTouristOffersTransport = async () => {
    if (id) {
      try {
        const data = await service.findOne(Number(id));
        const images = (data?.images || [])
          .filter(image => image.description !== 'Estruturas Anexas')
          .map(image => image.image);
        const structures = (data?.images || [])
          .filter(image => image.description === 'Estruturas Anexas')
          .map(image => image.image);
        const newTransport = {
          ...data,
          images,
          image: data?.image ? [data.image] : [],
          structures,
        };
        setSelectedTransport(newTransport);
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <>
      <MainTitle>Configurações</MainTitle>
      <Container>
        <Heading>{id ? 'Editar Transporte' : 'Novo Transporte'}</Heading>
        <TransportSeturForm selectedId={id} item={selectedTransport} />
      </Container>
    </>
  );
};

export default TransportForm;
